<nav class="navbar bolder navbar-expand-lg" role="navigation">
  <div class="container">

    <div class="navbar-brand nav-logo d-lg-inline-block">
      <a class="nav-logo-link" routerLink="/">
        <app-logo></app-logo>
      </a>
    </div>

    <div class="navbar-collapse d-flex mobile-justify-content-end">

      <!-- navigation links (and menu) -->
      <ul class="navbar-nav mr-auto left-nav mobile-display-footer border-top border-light-color">

        <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
          <a class="nav-link" routerLink="/" i18n="topnav my projects@@topnav-my-projects">My projects</a>
        </li>

        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/managed-projects" i18n="topnav managed projects@@topnav-managed-projects">Projects I manage</a>
        </li>

        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/all-projects" i18n="topnav all projects@@topnav-all-projects">All projects</a>
        </li>

      </ul>

      <div class="ml-3 pr-1 pr-md-0">
        <app-user-menu></app-user-menu>
      </div>

    </div>
  </div>
</nav>
